/*
 * あと○円で送料無料バー(カートページ・カートドロワー)
 * - しきい値: 15,000円(配送設定「15000円以上送料無料」と同じ。商品合計・割引後・税込で判定)
 * - /cart.js の total_price は円の100倍の値
 * - Dawnはカート更新のたびに中身を差し替えるので、バーが消えたら入れ直す
 */
(function () {
  var THRESHOLD_YEN = 15000;
  var TARGETS = ['#CartDrawer-CartItems', '#main-cart-items .js-contents'];
  var STYLE_ID = 'free-shipping-bar-style';
  var timer = null;
  var busy = false;

  function yen(n) {
    return n.toLocaleString('ja-JP') + '円';
  }

  function addStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var css =
      '.free-shipping-bar{margin:0 0 1.6rem;padding:1.2rem 1.4rem;border-radius:.8rem;background:rgba(var(--color-foreground),.04);text-align:center}' +
      '.free-shipping-bar__text{margin:0 0 .8rem;font-size:1.4rem;line-height:1.5}' +
      '.free-shipping-bar__text strong{font-size:1.6rem}' +
      '.free-shipping-bar__track{height:.8rem;border-radius:99rem;background:rgba(var(--color-foreground),.12);overflow:hidden}' +
      '.free-shipping-bar__fill{display:block;height:100%;border-radius:99rem;background:#b5402f;transition:width .4s ease}' +
      '.free-shipping-bar--done .free-shipping-bar__fill{background:#3f7d4e}' +
      '.free-shipping-bar__note{margin:.6rem 0 0;font-size:1.1rem;color:rgba(var(--color-foreground),.65)}' +
      '#CartDrawer-CartItems .free-shipping-bar{margin:0 0 .8rem;padding:.8rem 1rem}' +
      '#CartDrawer-CartItems .free-shipping-bar__text{margin:0 0 .5rem;font-size:1.3rem}' +
      '#CartDrawer-CartItems .free-shipping-bar__text strong{font-size:1.5rem}' +
      '#CartDrawer-CartItems .free-shipping-bar__track{height:.6rem}' +
      '#CartDrawer-CartItems .free-shipping-bar__note{margin-top:.4rem;font-size:1rem}';
    var el = document.createElement('style');
    el.id = STYLE_ID;
    el.textContent = css;
    document.head.appendChild(el);
  }

  function buildBar(totalYen) {
    var remaining = THRESHOLD_YEN - totalYen;
    var percent = Math.max(0, Math.min(100, Math.floor((totalYen / THRESHOLD_YEN) * 100)));
    var bar = document.createElement('div');
    bar.className = 'free-shipping-bar' + (remaining <= 0 ? ' free-shipping-bar--done' : '');
    bar.setAttribute('role', 'status');
    bar.innerHTML =
      '<p class="free-shipping-bar__text">' +
      (remaining > 0 ? 'あと<strong>' + yen(remaining) + '</strong>で送料無料' : '<strong>送料無料です</strong>') +
      '</p>' +
      '<div class="free-shipping-bar__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' +
      percent +
      '" aria-label="送料無料まで"><span class="free-shipping-bar__fill" style="width:' +
      percent +
      '%"></span></div>' +
      '<p class="free-shipping-bar__note">15,000円(税込)以上で送料無料 ※沖縄・離島を除く</p>';
    return bar;
  }

  function containersMissingBar() {
    var list = [];
    TARGETS.forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el && !el.querySelector(':scope > .free-shipping-bar')) list.push(el);
    });
    return list;
  }

  function render(force) {
    var targets = force
      ? TARGETS.map(function (s) { return document.querySelector(s); }).filter(Boolean)
      : containersMissingBar();
    if (!targets.length) return;
    if (busy) return schedule(force);
    busy = true;
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        targets.forEach(function (el) {
          var old = el.querySelector(':scope > .free-shipping-bar');
          if (old) old.remove();
          if (!cart.item_count) return;
          el.insertBefore(buildBar(Math.round(cart.total_price / 100)), el.firstChild);
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function schedule(force) {
    clearTimeout(timer);
    timer = setTimeout(function () { render(force); }, 150);
  }

  function init() {
    addStyle();
    render(true);
    new MutationObserver(function () { schedule(false); }).observe(document.body, { childList: true, subtree: true });
    // Dawn のカート更新イベント(数量変更など)でも入れ直す
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { schedule(true); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
